import dayjs from 'dayjs';

const dateIsValid = ( eventDate?: Date | string ) => dayjs( eventDate ).isValid();

export default dateIsValid;
